const utils = require('../../../lib/utils');

module.exports = {
	config: {
		preventFieldChangeOnInit: false
	},

	model: {
		$options: {},
		colors: {},
		keyDownLabel: ''
	},

	events: {
		toggle: {
			type: 'click',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target, value;
				if(($target = $(event.target).closest('.toggleOption')).length > 0){
					value = $target.data('value');
					event.data.component.select(value, $target.hasClass('disabled'));
				}
			}
		},

		hoverIn: {
			type: 'mouseenter',
			selector: "[data-value]",
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('[data-value]');
				if($target.length > 0){
					var value = $target.data('value');
					if(value !== undefined && (self.model.colors[value] || {}).hoverColor){
						$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].hoverColor);
						$target.css('color', self.model.colors[value].complementaryColor);
					}
				}
			}
		},
		hoverOut: {
			type: 'mouseleave',
			selector: "[data-value]",
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target).closest('[data-value]');
				if($target.length > 0){
					var value = $target.data('value');
					// prevent color reset in case no hover color has been defined
					if(value !== undefined && (self.model.colors[value] || {}).hoverColor){
						if($target.hasClass('selected')){
							if((self.model.colors[value] || {}).activeColor){
								$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].activeColor);
								$target.css('color', self.model.colors[value].complementaryColor);
							}
						} else if((self.model.colors[value] || {}).color){
							$target[0].style.setProperty('--toggle-bg-color', self.model.colors[value].color);
							$target.css('color', self.model.colors[value].fontColor);						}
					}
				}
			}
		},
	},

	methods: {
		prepare: function(storage, isServer, options){
			this.model.config = this.model.config || {};
			this.prepareMeta(storage, isServer, options);
		},

		prepareStaticOptions: function(dataType, dataFlag){
			var self = this;
			var fieldConfig = self.model.config || {};

			if(fieldConfig.colors){
				self.model.colors = fieldConfig.colors
			}

			if(dataType === 'boolean' && !self.model[dataFlag]){
				if(fieldConfig.strict){
					self.model[dataFlag] = {
						options: [
							{ name: __('dataValues.boolean.1'), value: 1, defaultSelected: fieldConfig.default, color: ((self.model.colors || {})[1] || {}).color, config: { fontColor: ((self.model.colors || {})[1] || {}).fontColor, complementaryColor: ((self.model.colors || {})[1] || {}).complementaryColor }},
							{ name: __('dataValues.boolean.0'), value: 0, defaultSelected: !fieldConfig.default, color: ((self.model.colors || {})[0] || {}).color, config: { fontColor: ((self.model.colors || {})[0] || {}).fontColor, complementaryColor: ((self.model.colors || {})[0] || {}).complementaryColor } }
						]
					};
				} else {
					self.model[dataFlag] = {
						options: [
							{ name: __('dataValues.boolean.all'), value: undefined, defaultSelected: fieldConfig.default === undefined },
							{ name: __('dataValues.boolean.1'), value: 1, defaultSelected: fieldConfig.default !== undefined && fieldConfig.default, color: ((self.model.colors || {})[1] || {}).color, config: { fontColor: ((self.model.colors || {})[1] || {}).fontColor, complementaryColor: ((self.model.colors || {})[1] || {}).complementaryColor } },
							{ name: __('dataValues.boolean.0'), value: 0, defaultSelected: fieldConfig.default !== undefined && !fieldConfig.default, color: ((self.model.colors || {})[0] || {}).color, config: { fontColor: ((self.model.colors || {})[0] || {}).fontColor, complementaryColor: ((self.model.colors || {})[0] || {}).complementaryColor } }
						]
					};
				}
			}
		},

		prepareMeta: function(storage, isServer, options){
			storage = storage || window.storage;
			isServer = isServer || false;
			options = options || { refresh: true };
			var self = this;

			self.model.isDisabled = false;
			self.model.isFilterField = false;
			if((self.formMapping || {}).fieldConfig) {
				self.model.isDisabled 		= Boolean(self.formMapping.fieldConfig.disabled);
				self.model.isFilterField 	= Boolean(self.formMapping.fieldConfig.isFilterField);
			}

			if(!options.refresh && self.model.isFilterField && self.model.value !== self.model.filterValue){
				self.model.value = self.model.filterValue;
			}
			
			// prepare config
			self.model.renderConfig = (self.model.config || {}).renderConfig || {};
			self.model.childConfig = self.model.renderConfig.optionEntries || {};
			self.model.childConfig = utils.replace({ value: 'value', name: 'name' }, self.model.childConfig);

			// prepare user-lang
			var langCode;
			if(storage.user && storage.user.data && storage.user.data.langCode){
				langCode = storage.user.data.langCode;
			}

			// prepare data-type
			var dataType;
			if(self.model.atom && self.model.atom.dataType){
				dataType = self.model.atom.dataType;
			}

			// prepare source-data-flag
			if(dataType){
				self.model.dataAttributeKey = dataType + '-data';
			} else {
				self.model.dataAttributeKey = 'data';
			}
			self.prepareStaticOptions(dataType, self.model.dataAttributeKey);

			// prepare options
			self.model.options = [];
			if(Array.isArray(self.model[self.model.dataAttributeKey])){
				self.model.options = self.model[self.model.dataAttributeKey];
			}
			else if(!!self.model[self.model.dataAttributeKey] && !!self.model[self.model.dataAttributeKey].options){
				self.model.options = self.model[self.model.dataAttributeKey].options;
			}

			// prepare default entry
			if(self.model.renderConfig.defaultOptionEntry){
				var entry = {
					defaultSelected: true
				};
				if(langCode && self.model.renderConfig.defaultOptionEntry.lang && self.model.renderConfig.defaultOptionEntry.lang[langCode]){
					entry[self.model.childConfig.name] = self.model.renderConfig.defaultOptionEntry.lang[langCode];
					entry[self.model.childConfig.value] = self.model.renderConfig.defaultOptionEntry.value;
				}
				else {
					entry[self.model.childConfig.name] = self.model.renderConfig.defaultOptionEntry.name;
					entry[self.model.childConfig.value] = self.model.renderConfig.defaultOptionEntry.value;
				}
				self.model.options.unshift(entry);
			}

			self.model.selectedChildIndex = undefined;
			if(self.model.options) {
				var optionValue;
				var defaultSelectedChildIndex;
				var optionDisabled = false;
				var nonDisabledChildIndexes = [];
				utils.forEach(self.model.options, function (child, childIndex) {
					// define options' value
					optionValue = child[self.model.childConfig.value];
					optionDisabled = (self.model.disabledValues || {})[optionValue];
					if (!optionDisabled) {
						nonDisabledChildIndexes.push(childIndex);

						if(!self.model.colors) 					self.model.colors = {};
						if(!self.model.colors[optionValue]) 	self.model.colors[optionValue] = {};
						if(child.color) 						self.model.colors[optionValue].color 		= child.color;
						if((child.config || {}).hoverColor) 	self.model.colors[optionValue].hoverColor 	= child.config.hoverColor;
						if((child.config || {}).activeColor) 	self.model.colors[optionValue].activeColor 	= child.config.activeColor;
						if((child.config || {}).complementaryColor) 	self.model.colors[optionValue].complementaryColor 	= child.config.complementaryColor;
						if((child.config || {}).fontColor) 				self.model.colors[optionValue].fontColor 			= child.config.fontColor;
					}

					// define if option is selected
					if (Array.isArray(self.model.dataJSON)) {
						if (utils.indexOf(self.model.dataJSON, optionValue) >= 0) {
							self.model.selectedChildIndex = childIndex;
						}
					} else if (self.model.isFilterField) {
						if (dataType === 'boolean') {
							if (optionValue === self.model.filterValue) {
								self.model.selectedChildIndex = childIndex;
							}
						}
						else {
							if (optionValue == self.model.filterValue) {
								self.model.selectedChildIndex = childIndex;
							}
						}
					} else if (self.model.dataTEXT != undefined && (dataType === 'template-picker' || dataType === 'text')) {
						if (optionValue == self.model.dataTEXT) {
							self.model.selectedChildIndex = childIndex;
						}
					} else if ((dataType === 'boolean' || dataType === 'integer') && optionValue == self.model.dataINT && self.model.dataINT !== undefined) {
						self.model.selectedChildIndex = childIndex;
					} else if (self.model.value === optionValue && optionValue !== undefined) {
						self.model.selectedChildIndex = childIndex;
					} else {
						if (!!child.defaultSelected && !optionDisabled) {
							defaultSelectedChildIndex = childIndex;
						}
					}
				});

				// check if selected values are disabled
				var selectedIsDisabled = false;
				var defaultSelectedIsDisabled = false;
				if(self.model.selectedChildIndex !== undefined){
					selectedIsDisabled = (self.model.disabledValues || {})[self.model.options[self.model.selectedChildIndex][self.model.childConfig.value]];
				}
				if(defaultSelectedChildIndex !== undefined){
					defaultSelectedIsDisabled = (self.model.disabledValues || {})[self.model.options[defaultSelectedChildIndex][self.model.childConfig.value]];
				}

				// select right value
				if (self.model.selectedChildIndex !== undefined && !selectedIsDisabled) {
					defaultSelectedChildIndex = undefined;
				}
				else if (defaultSelectedChildIndex !== undefined && !defaultSelectedIsDisabled) {
					self.model.selectedChildIndex = defaultSelectedChildIndex;
				} else if (nonDisabledChildIndexes.length > 0) {
					self.model.selectedChildIndex = nonDisabledChildIndexes[0];
				} else {
					self.model.selectedChildIndex = undefined;
				}

				// save new selection if it has changed
				if(self.model.selectedChildIndex !== undefined){
					var newValue = self.model.options[self.model.selectedChildIndex][self.model.childConfig.value];
					if(self.model.value != newValue){
						self.model.value = newValue;
						if(!isServer && !self.config.preventFieldChangeOnInit){
							self.parent(function(parentComponent){
								parentComponent.trigger('onChildChanged', {
									fieldCode:  self.model.fieldCode,
									value:      newValue
								});
							});
						}
					}
				}
			}
		},

		select: function(value, fieldIsDisabled){
			var self = this;
			if(self.model.isDisabled || fieldIsDisabled) return;

			var atom = self.model.atom || {};

			if(atom.dataType === 'boolean'){
				if(value === '')	value = undefined;
				else                value = parseInt(value);
			}

			if(self.model.value !== value){
				var $toggleOption;
				if(
					($toggleOption = self.model.$options.filter('[data-value="' + value + '"]')).length > 0 ||
					((value === null || value === undefined) && ($toggleOption = self.model.$options.filter('[data-value=""], :not([data-value])')).length > 0)
				){
					// reset color of actual selected toggle if necessary
					var $previouslySelectedToggle = self.model.$options.filter('.selected');
					if($previouslySelectedToggle.length > 0){
						var previousValue = $previouslySelectedToggle.data('value');
						if(previousValue !== undefined && ((self.model.colors || {})[previousValue] || {}).color){
							$previouslySelectedToggle[0].style.setProperty('--toggle-bg-color', self.model.colors[previousValue].color);
							$previouslySelectedToggle.css('color', self.model.colors[previousValue].fontColor);
						}
					}

					if(value === '' || value === undefined) value = null;
					self.model.value = value;
					self.model.$options.removeClass('selected');
					$toggleOption.addClass('selected');

					var optionIndex;
					for(optionIndex in self.model.options || []){
						if(self.model.options[optionIndex].value === value){
							self.model.selectedChildIndex = optionIndex;
							break;
						}
					}

					// set right value flag
					if (Array.isArray(self.model.dataJSON)) {
						self.model.dataJSON = [value];
					} else if (self.model.isFilterField) {
						self.model.filterValue = value;
					} else if (self.model.dataTEXT != undefined && (atom.dataType === 'template-picker' || atom.dataType === 'text')) {
						self.model.dataTEXT = value
					} else if (atom.dataType === 'boolean') {
						self.model.dataINT = value;
					}

					this.updateKeyDownLabelValue(value);

					self.parent(function(parentComponent){
						parentComponent.trigger('onChildChanged', {
							fieldCode:  self.model.fieldCode,
							value:      value
						});
					});
				}
			}
		},

		updateKeyDownLabelValue: function(value){
			var self = this;
			if(self.model.config.keyDownLabel || self.model.config.keyDownLabelTriggerOnly){
				self.parent(function(parentComponent){
					self.model.keyDownLabel = parentComponent.updateKeyDownLabelValue(self.model.fieldCode, self.model.config, value);
				});

				if(self.model.config.keyDownLabel && self.$){
					self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
				}
			}
		},
	},

	hooks: {
		attach: function($element, options){
			this.model.$options = $element.find('.toggleOption');
		},

		updateKeyDownLabelValue: function($element, options){
			var self = this;
			if(self.model.config.keyDownLabel && self.$ && options.value){
				self.model.keyDownLabel = options.value;
				self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
			}
		}
	}
};